module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/house-3c42090d6ffb148aa3e1a4c79cc84e5b.jpg";